import React, { useEffect, useState } from "react";
import { referral_window_open } from './utils/constatnts';
import "./Statuswidget.css";
import axiosInstance from "./utils/axios";

export default function Statuswidget(props: any) {
  const [countdown, setCountdown] = useState<any>({ days: "00", hours: "00", minutes: "00", seconds: "00"});
  const targetDate: any = new Date("2026-09-18T23:59:59"); // Set your target date and time
  useEffect(() => {
    // console.log('Widget received new status:', props.statusWidgetCount);
    const interval = setInterval(() => {
      const now: any = new Date();
      const timeDifference = targetDate - now;

      if (timeDifference > 0) {
        const days: any = Math.floor(timeDifference / (1000 * 60 * 60 * 24))
          .toString()
          .padStart(2, "0");
        const hours: any = Math.floor(
          (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        )
          .toString()
          .padStart(2, "0");
        const minutes: any = Math.floor(
          (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
        )
          .toString()
          .padStart(2, "0");
        const seconds: any = Math.floor((timeDifference % (1000 * 60)) / 1000)
          .toString()
          .padStart(2, "0");

        setCountdown({ days, hours, minutes, seconds });
      } else {
        clearInterval(interval);
        setCountdown({ days: "0", hours: "0", minutes: "0", seconds: "00" });
      }
    }, 1000);
    // console.log('Widget received status:', props.statusWidgetCount);
    return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.tabLabelValue, props.statusWidgetCount]);

  // const downloadOpenPositions = () => {
  //   // Replace 'path/to/your/excel/file.xlsx' with the actual path to your Excel file
  //   const excelpath = './assets/Open Positions-June_2024.xlsx';

  //   // Create a link element
  //   const link = document.createElement('a');
  //   link.href = excelpath;
  //   link.download = 'Open Positions-June_2024.xlsx';

  //   // Trigger a click on the link to start the download
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  const downloadOpenPositions = async () => {
    try {
        const response = await axiosInstance.get('/candidatelist/download', {
            responseType: 'blob',
            headers: {
                "Content-Type": "application/json",
            },
        });

        // Convert the response to Blob
        const blob = new Blob([response.data], { type: (response.headers['content-type'] as string) || 'application/octet-stream' });

        // Create a link element
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Open Positions-September_2026.xlsx';
        document.body.appendChild(a);

        // Programmatically click the link to trigger the download
        a.click();

        // Clean up: remove the link and revoke the URL
        window.URL.revokeObjectURL(url);
        a.remove();
    } catch (error) {
        console.error('Error downloading file:', error);
    }
  };

  return (
    <div style={{display:"flex"}}>
      <div className="widget-section">
        <div className="roles_count">
          <div className="count-tile" style={{ background: "rgb(119,78,167)" }}>
            <div className="count-number-section">48</div>
            <div className="count-content">Cable Open Roles</div>
          </div>
          <div
            className="count-tile"
            style={{ marginTop: "1em", background: "#03a9f4" }}
          >
            <div className="count-number-section">3</div>
            <div className="count-content">SKY Open Roles</div>
          </div>
          <div
            className="count-tile"
            style={{ marginTop: "1em", background: "#fa9f1b" }}
          >
            <div className="count-number-section">10</div>
            <div className="count-content">NBCU Open Roles</div>
          </div>
        </div>

        <div className="total-opencount">
          <div className="totalcount-title">Total Openings</div>
          <div className="total-count">61</div>
          <div className="supplement-title">
            As on Date ,
            {new Date().toLocaleString("en-IN", {
              day: "2-digit",
              month: "long",
              year: "numeric",
            })}
          </div>
        </div>
      </div>
      <div className="time-counter">
        <div style={{ fontSize: "20px", fontWeight: "600", color: "#373c43" }}>
          { referral_window_open ? "Referral Window Closes On" : "Referral Window Closed"}
        </div>
        <div className="counter-section">
          <div className="countdown">
            <div className="countdown-item">
              <div className="countdown-tile-section">
                <span className="countdown-tile">{countdown.days}</span>
              </div>
              <span className="timecount-section"> Days </span>
            </div>
            <div className="countdown-item">
              <div className="countdown-tile-section">
                <span className="countdown-tile">{countdown.hours}</span>
              </div>
              <span className="timecount-section"> Hours </span>
            </div>
            <div className="countdown-item">
              <div className="countdown-tile-section">
                <span className="countdown-tile">{countdown.minutes}</span>
              </div>
              <span className="timecount-section"> Mintues </span>
            </div>
            <div className="countdown-item">
              <div className="countdown-tile-section">
                <span className="countdown-tile">{countdown.seconds}</span>
              </div>
              <span className="timecount-section"> Seconds </span>
            </div>
          </div>
        </div>
      </div>
      {props.tabLabelValue === "Candidate Status" ?
        <div className="status-section">
          <div className="status-referral-title">Candidate Referral Status</div>
          <div className="status-title-section">
            <div className="status-title-count">
              {props.getTotalStatusCount}
            </div>
            <div className="status-title-content">
              Total
            </div>
          </div>
          <div className="status-each-section">
            
            <div className="status-topcount-section">
              <div className="status-item">
                <div className="status-item-count" style ={{color:"#03a9f4"}}>
                  { (props.statusWidgetCount["New"] || 0) + (props.statusWidgetCount["Interviews are in Progress"] || 0) + 
                      (props.statusWidgetCount["Shared for Hiring Manager Review"] || 0)}
                </div>
                <div className="status-item-content">
                    Review
                </div>
              </div>
              <div className="status-item"> 
                <div className="status-item-count" style ={{color:"#fa9f1b"}}>
                  { (props.statusWidgetCount["Final Select"] || 0) + (props.statusWidgetCount["Offered"] || 0) + 
                    (props.statusWidgetCount["Joined"] || 0) + (props.statusWidgetCount["Offer Declined"] || 0)}
                </div>
                <div className="status-item-content">
                  Selected
                </div>
              </div>
            </div>
            <div className="status-topcount-section" style={{borderTop:"1px solid #ccc", paddingTop:"10px"}}>
              <div className="status-item">
                <div className="status-item-count" style ={{color:"#df5645"}}>
                  { (props.statusWidgetCount["Profile Reject"] || 0) + (props.statusWidgetCount["Technical Reject"] || 0) + 
                    (props.statusWidgetCount["Manager Reject"] || 0) + (props.statusWidgetCount["HR Reject"]|| 0) + 
                    (props.statusWidgetCount["Resume saved in the Database"] || 0) + (props.statusWidgetCount["Position Filled"] || 0)} 
                </div>
                <div className="status-item-content">
                    Rejected
                </div>
              </div>
              <div className="status-item"> 
                <div className="status-item-count" style ={{color:"#26a69a"}}>
                  {(props.statusWidgetCount["Position on hold"] || 0) + (props.statusWidgetCount["Candidate on hold"] || 0)}
                </div>
                <div className="status-item-content">
                  Hold
                </div>
              </div>
            </div>
          </div>
        </div>
        :
        <div className="info-section">
            <div className="info-title">
                  <span style={{color:"#f14545"}}>***</span> List Of Open Positions <span style={{color:"#f14545"}}>***</span>
              </div>
              <div className="info-content">
                  <ul style={{padding:0}}>
                      <li>Please refer the below attached sheet to find the list of current Open Roles
                        <span className="download-link" onClick={downloadOpenPositions}><b><em> (Open Positions-September_2026) </em></b></span>
                      </li>
                      {/* <li>Kindly choose the appropriate business unit and open position id.</li>
                      <li>Referral Bonus will be given as per standard policy and conditions</li> */}
                  </ul>
              </div>     
        </div>
    }
    </div>
  );
}
